import React from "react";
import { Box, Button, Grid } from "@mui/material";
import { useHistory } from "react-router-dom";
import pageStyles from "../../pages/pageStyles";

interface FormSubmitButtonsProps {
  submitAction?: () => void;
  isDisabled?: boolean;
  isFixed?: boolean; // fixed position or not
}

const FormSubmitButtons = (props: FormSubmitButtonsProps) => {
  const { submitAction, isDisabled = false, isFixed = true } = props;
  const history = useHistory();
  const classes = pageStyles();

  return (
    <Grid item xs={12} className={isFixed ? classes.actionButtonWrapper : ""}>
      <Box className={isFixed ? classes.stickyActionButton : ""}>
        <Box display="flex" justifyContent="flex-end">
          <Box mr={2}>
            <Button
              variant="contained"
              size="large"
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
          </Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            disabled={isDisabled}
            onClick={submitAction}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default FormSubmitButtons;
